import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "faq-list" }
const _hoisted_2 = { class: "faq-half-list" }
const _hoisted_3 = { class: "faq-half-list" }
const _hoisted_4 = { class: "faq-list" }
const _hoisted_5 = { class: "faq-half-list" }
const _hoisted_6 = { class: "faq-half-list" }
const _hoisted_7 = { class: "faq-list" }
const _hoisted_8 = { class: "faq-half-list" }
const _hoisted_9 = { class: "faq-half-list" }
const _hoisted_10 = { class: "faq-list" }
const _hoisted_11 = { class: "faq-half-list" }
const _hoisted_12 = { class: "faq-half-list" }
const _hoisted_13 = { class: "support-remark" }

import { onBeforeMount, ref } from 'vue'
import type { Raw, Ref } from 'vue'

import ChangelogPopup from '@/app/components/changelog/Popup.vue'
import { createChangelogView } from '@/models/changelog'
import type { ChangelogView } from '@/models/changelog'
import * as Mixpanel from '@/analytics/mixpanel/mixpanel'
import { assertNotNull } from '@/helpers/typing'
import { scrollIntoView } from '@/helpers/dom'

import FAQSectionLayout from './FAQSectionLayout.vue'
import FAQUnit from './FAQUnit.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportFAQ',
  setup(__props) {

const popupChangelog = ref<InstanceType<typeof ChangelogPopup> | null>(null)
const changelogView: Ref<Raw<ChangelogView> | null> = ref(null)

onBeforeMount(async () => {
  changelogView.value = await createChangelogView()
})

async function toggleChangelogDialog(): Promise<void> {
  await changelogView.value?.loadData()
  assertNotNull(popupChangelog.value).show()
  Mixpanel.trackChangelogButtonClick()
}

function scrollToSupport(): void {
  scrollIntoView('#support', { behaviour: 'smooth' })
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(FAQSectionLayout, null, {
    default: _withCtx(() => [
      _cache[78] || (_cache[78] = _createElementVNode("h3", { class: "faq-box__subtitle" }, "Shortform App", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FAQUnit, {
            type: "support",
            title: "What devices can I use Shortform on?"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" The Shortform app is available on ", -1),
              _createElementVNode("a", {
                href: "https://apps.apple.com/us/app/shortform-daily-book-summaries/id1489472007",
                target: "_blank"
              }, " iOS ", -1),
              _createTextVNode(", ", -1),
              _createElementVNode("a", {
                href: "https://play.google.com/store/apps/details?id=com.shortform.app",
                target: "_blank"
              }, "Android", -1),
              _createTextVNode(", and ", -1),
              _createElementVNode("a", {
                href: "https://www.shortform.com/",
                target: "_blank"
              }, "Desktop", -1),
              _createTextVNode(". ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(FAQUnit, {
            type: "support",
            title: "How can I request a book summary?"
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createTextVNode(" Send us a request with the title you'd like to see covered using ", -1)),
              _createVNode(_component_RouterLink, {
                to: "/app/help#support",
                onClick: scrollToSupport
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" the form on this page ", -1)
                ]))]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" or email us at ", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("a", { href: "mailto:help@shortform.com" }, "help@shortform.com", -1)),
              _cache[5] || (_cache[5] = _createTextVNode(". ", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(FAQUnit, {
            type: "support",
            title: "How can I make the most of my Shortform subscription?"
          }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createTextVNode(" Click ", -1)),
              _createElementVNode("button", {
                class: "",
                onClick: toggleChangelogDialog
              }, " here to open the “what’s new” screen "),
              _cache[7] || (_cache[7] = _createTextVNode(" and find out more about the app features. ", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
              _cache[10] || (_cache[10] = _createTextVNode(" Also check out ", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("a", {
                href: "https://www.shortform.com/blog/how-to-use-shortform/",
                target: "_blank"
              }, " this article ", -1)),
              _cache[12] || (_cache[12] = _createTextVNode(" for an in-depth look at all of Shortform's features. ", -1))
            ]),
            _: 1
          }),
          _createVNode(FAQUnit, {
            type: "support",
            title: "Where can I report a technical problem or bug?"
          }, {
            default: _withCtx(() => [
              _cache[14] || (_cache[14] = _createTextVNode(" Please report all bugs to the support team using the ", -1)),
              _createVNode(_component_RouterLink, {
                to: "/app/help#support",
                onClick: scrollToSupport
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode(" Support Request form ", -1)
                ]))]),
                _: 1
              }),
              _cache[15] || (_cache[15] = _createTextVNode(" on this page or email us directly at ", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("a", { href: "mailto:help@shortform.com" }, "help@shortform.com", -1)),
              _cache[17] || (_cache[17] = _createTextVNode(". ", -1))
            ]),
            _: 1
          })
        ])
      ]),
      _cache[79] || (_cache[79] = _createElementVNode("h3", { class: "faq-box__subtitle" }, "Account", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(FAQUnit, {
            type: "support",
            title: "How do I change my password?"
          }, {
            default: _withCtx(() => [
              _cache[19] || (_cache[19] = _createTextVNode(" You can reset your password by navigating to your account ", -1)),
              _createVNode(_component_RouterLink, { to: "/app/settings" }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("Settings", -1)
                ]))]),
                _: 1
              }),
              _cache[20] || (_cache[20] = _createTextVNode(" and clicking the “Change Password” button. ", -1))
            ]),
            _: 1
          }),
          _createVNode(FAQUnit, {
            type: "support",
            title: "How can I change the language settings on my account?"
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode(" Shortform is available in English, Español, Deutsch, and Português Brasileiro. To change the language that displays on the app for you, click the profile icon (top right). Then, click the Language dropdown menu and choose a language. ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(FAQUnit, {
            type: "support",
            title: "Can I change the email associated with my account?"
          }, {
            default: _withCtx(() => [
              _cache[23] || (_cache[23] = _createTextVNode(" Yes, you can change your email by navigating to your account ", -1)),
              _createVNode(_component_RouterLink, { to: "/app/settings" }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("Settings", -1)
                ]))]),
                _: 1
              }),
              _cache[24] || (_cache[24] = _createTextVNode(" and clicking the “Change Email” button. ", -1))
            ]),
            _: 1
          }),
          _createVNode(FAQUnit, {
            type: "support",
            title: "How do I permanently delete my Shortform account?"
          }, {
            default: _withCtx(() => [
              _cache[26] || (_cache[26] = _createTextVNode(" You can delete your account on the ", -1)),
              _createVNode(_component_RouterLink, { to: "/app/settings" }, {
                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                  _createTextVNode("Settings", -1)
                ]))]),
                _: 1
              }),
              _cache[27] || (_cache[27] = _createTextVNode(" screen. Your account and your data will be permanently deleted. ", -1)),
              _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
              _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
              _cache[30] || (_cache[30] = _createTextVNode(" Alternatively, you may want to keep your account but cancel your paid plan so you have the option to resubscribe to a paid plan at a later time without losing your data. ", -1))
            ]),
            _: 1
          })
        ])
      ]),
      _cache[80] || (_cache[80] = _createElementVNode("h3", { class: "faq-box__subtitle" }, "Free Trial", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(FAQUnit, {
            type: "support",
            title: "What happens after my free trial ends?"
          }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
              _createTextVNode(" If you do not cancel your free trial before the end date, then the card on file will be automatically charged for the subscription plan you chose at the start of your trial. ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(FAQUnit, {
            type: "support",
            title: "Can I cancel my Shortform free trial before it ends?"
          }, {
            default: _withCtx(() => [
              _cache[33] || (_cache[33] = _createElementVNode("strong", null, "If you started your trial through the web", -1)),
              _cache[34] || (_cache[34] = _createTextVNode(", you can cancel your free trial before the end date from the ", -1)),
              _createVNode(_component_RouterLink, { to: "/app/billing" }, {
                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                  _createTextVNode("Billing", -1)
                ]))]),
                _: 1
              }),
              _cache[35] || (_cache[35] = _createTextVNode(" screen. Keep in mind that when you cancel during a free trial, you will lose access to Shortform content. You can restart the trial at any point before the original end date of the trial period. The end date remains the same. ", -1)),
              _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
              _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
              _cache[38] || (_cache[38] = _createElementVNode("strong", null, "If you started your trial on the mobile app", -1)),
              _cache[39] || (_cache[39] = _createTextVNode(", your payments are managed through either Apple or Google. You may cancel your trial and continue to access Shortform content through your full trial period. ", -1))
            ]),
            _: 1
          })
        ])
      ]),
      _cache[81] || (_cache[81] = _createElementVNode("h3", { class: "faq-box__subtitle" }, "Payment and Subscription", -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(FAQUnit, {
            type: "support",
            title: "How can I update my payment information?"
          }, {
            default: _withCtx(() => [
              _cache[41] || (_cache[41] = _createElementVNode("strong", null, "If you subscribed on the Shortform website or app:", -1)),
              _cache[42] || (_cache[42] = _createTextVNode(" You can change your payment method by tapping “Edit” in the “Payment Information” box on the ", -1)),
              _createVNode(_component_RouterLink, { to: "/app/billing" }, {
                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                  _createTextVNode("Billing", -1)
                ]))]),
                _: 1
              }),
              _cache[43] || (_cache[43] = _createTextVNode(" screen. ", -1)),
              _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
              _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
              _cache[46] || (_cache[46] = _createElementVNode("strong", null, "If you subscribed through Apple App Store:", -1)),
              _cache[47] || (_cache[47] = _createTextVNode(" You can manage your payment settings in the AppStore app. ", -1)),
              _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
              _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
              _cache[50] || (_cache[50] = _createElementVNode("strong", null, "If you subscribed through Google Play:", -1)),
              _cache[51] || (_cache[51] = _createTextVNode(" You can manage your payment settings in the Google Play app. ", -1))
            ]),
            _: 1
          }),
          _createVNode(FAQUnit, {
            type: "support",
            title: "How can I cancel my Shortform subscription?"
          }, {
            default: _withCtx(() => [
              _cache[53] || (_cache[53] = _createElementVNode("strong", null, "If you subscribed on the Shortform website or app:", -1)),
              _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1)),
              _cache[55] || (_cache[55] = _createTextVNode(" Visit our ", -1)),
              _createVNode(_component_RouterLink, { to: "/app/billing" }, {
                default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                  _createTextVNode("Billing", -1)
                ]))]),
                _: 1
              }),
              _cache[56] || (_cache[56] = _createTextVNode(" page → Click “Cancel subscription.”", -1)),
              _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
              _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1)),
              _cache[59] || (_cache[59] = _createElementVNode("strong", null, "If you subscribed through Apple App Store:", -1)),
              _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
              _cache[61] || (_cache[61] = _createTextVNode(" Use iOS Settings app → Your Name → Subscriptions → Shortform → Cancel.", -1)),
              _cache[62] || (_cache[62] = _createElementVNode("br", null, null, -1)),
              _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
              _cache[64] || (_cache[64] = _createElementVNode("strong", null, "If you subscribed through Google Play:", -1)),
              _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
              _cache[66] || (_cache[66] = _createTextVNode(" In the Google Play app → Profile → Payments & Subscriptions → Subscriptions → Shortform → Cancel.", -1)),
              _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
              _cache[68] || (_cache[68] = _createElementVNode("br", null, null, -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(FAQUnit, {
            type: "support",
            title: "Can I switch from a monthly to an annual subscription?"
          }, {
            default: _withCtx(() => [
              _cache[70] || (_cache[70] = _createTextVNode(" You can change your plan at any time on the ", -1)),
              _createVNode(_component_RouterLink, { to: "/app/billing" }, {
                default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                  _createTextVNode("Billing", -1)
                ]))]),
                _: 1
              }),
              _cache[71] || (_cache[71] = _createTextVNode(" page. ", -1))
            ]),
            _: 1
          }),
          _createVNode(FAQUnit, {
            type: "support",
            title: "If I cancel, will I still have access to Shortform until the end of my subscription?"
          }, {
            default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
              _createElementVNode("strong", null, "Yes.", -1),
              _createTextVNode(" When you cancel, your subscription stays active until the end of the billing period you’ve already paid for. You won’t lose access immediately. ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[74] || (_cache[74] = _createTextVNode(" Didn’t find an answer to your question? ", -1)),
        _createVNode(_component_RouterLink, {
          to: "/app/help#support",
          class: "support-remark__link",
          onClick: scrollToSupport
        }, {
          default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
            _createTextVNode(" Fill out the form above ", -1)
          ]))]),
          _: 1
        }),
        _cache[75] || (_cache[75] = _createTextVNode(" or send us an email directly at ", -1)),
        _cache[76] || (_cache[76] = _createElementVNode("a", { href: "mailto:help@shortform.com" }, "help@shortform.com", -1)),
        _cache[77] || (_cache[77] = _createTextVNode(". ", -1))
      ]),
      (_openBlock(), _createBlock(_Teleport, { to: "#appRoot" }, [
        _createVNode(ChangelogPopup, {
          ref_key: "popupChangelog",
          ref: popupChangelog,
          view: changelogView.value!
        }, null, 8, ["view"])
      ]))
    ]),
    _: 1
  }))
}
}

})